import { useAppSelector } from '@frontend/common';
import { FunctionalityConstraintData, isFunctionalityConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { FunctionalityConstraintDataInputProps } from './functionality-constraint-data-input.component';

interface ViewProps {
    formValues: FunctionalityConstraintData;
}

const useFunctionalityConstraintDataInput = (props: FunctionalityConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isFunctionalityConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { functionality_id: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useFunctionalityConstraintDataInput;
